import { Typography } from '@mui/material';
import React, { memo } from 'react';
import { makeStyles } from 'tss-react/mui';

// CUSTOM
import StdDialog from 'components/Dialogs/StdDialog';
import QButton from 'components/QButton';

const useStyles = makeStyles()((theme) => ({
  deleteButton: {
    marginRight: 16,
  },
  actions: {
    position: 'absolute',
    width: '100%',
    bottom: 0,
    left: 0,
    padding: theme.spacing(0, 3, 3),
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  header: {
    padding: theme.spacing(3),
  },
}));

type Props = {
  onClose: () => void;
  open: boolean;
  closeAll: () => void;
  update: () => void;
  create: boolean;
  notComplete: boolean;
  continueAfterDiscard?: boolean;
  continueAfterUpdate?: boolean;
};

function UnsavedChangesDialog({
  onClose,
  open,
  closeAll,
  update,
  create,
  notComplete,
  continueAfterDiscard = false,
  continueAfterUpdate = false,
}: Props) {
  const { classes } = useStyles();
  const continueFlow = continueAfterDiscard || continueAfterUpdate;

  return (
    <StdDialog title={create || notComplete ? 'Unsaved transaction' : 'Unsaved changes'} onClose={onClose} open={open}>
      <div className={classes.header}>
        <Typography variant='titleRegular'>
          {continueFlow
            ? `There are unsaved changes. Do you want to ${
                continueAfterUpdate ? (create ? 'create' : 'update') : 'discard'
              } this transaction before continuing?`
            : `There are unsaved changes.${
                notComplete
                  ? ' Do you want to continue editing or discard the transaction?'
                  : ` Before closing, do you want to ${create ? 'save' : 'update'} this transaction?`
              }`}
        </Typography>
      </div>
      <div className={classes.actions}>
        <QButton
          onClick={() => {
            onClose();
            closeAll();
          }}
          id='discard-changes'
          aria-label='discard-changes'
          variant='delete'
          disableOutline
          className={classes.deleteButton}
        >
          {continueFlow ? 'Discard & Continue' : create || notComplete ? 'Discard Transaction' : 'Discard Changes'}
        </QButton>
        {notComplete ? (
          <QButton onClick={onClose} id='back-to-edit' variant='outlined' aria-label='back-to-edit'>
            Back To Edit
          </QButton>
        ) : (
          <QButton
            onClick={() => {
              onClose();
              update();
            }}
            id='delete-txn'
            variant='contained'
            aria-label='delete-txn'
          >
            {continueFlow ? `${create ? 'Create' : 'Update'} & Continue` : create ? 'Create' : 'Update'}
          </QButton>
        )}
      </div>
    </StdDialog>
  );
}

export default memo(UnsavedChangesDialog);
